import config from 'src/constants/config';
import htmlParse from 'html-react-parser';
import NormalButton from 'src/components/Buttons/NormalButton';
import React from 'react';
import SVG from 'src/components/Images/SvgRenderer';
import useStyles from './style';
import { getUserRole } from 'src/utils/useUser';
import { useAppSelector } from 'src/hooks/redux-hooks';
import { useTranslation } from 'react-i18next';

type SectionType = {
  handleNext: any;
};

const Default: React.FunctionComponent<SectionType> = ({ handleNext }) => {
  
  const userData = useAppSelector((state: any) => state.user);

  const { t } = useTranslation();

  const classes = useStyles({
    role: getUserRole(userData.userObject.roleType)
  });

  const handleContinue = () => {
    handleNext();
  };

  const contentData: any = {
    title: {
      director: "Vítejte ve světě",
      teacher: "Vítejte ve světě",
      parent: "Vítejte ve světě",
    },
    text: {
      director: "Jsme rádi, že jste se k nám připojili. <b>Twigsee pomůže snadno zaznamenávat a sdílet důležité momenty ze života Vaší školky a uleví s administrací.</b> Kliknutím na \"Další\" se dozvíte více.",
      teacher: "Jsme rádi, že jste se k nám připojili. <b>Twigsee pomůže snadno zaznamenávat a sdílet důležité momenty ze života Vaší školky a uleví s administrací.</b> Kliknutím na \"Další\" se dozvíte více.",
      parent: "Twigsee vám umožní být v kontaktu se školkou vašeho dítěte. Získejte aktuální informace o pokrocích, aktivitách a událostech ve školce. Klikněte na “Další” a zjistěte, jak snadné to je.",
    },
  };

  const getContent = (type: any) => {
    return htmlParse(contentData[type][getUserRole(userData.userObject.roleType)]);
  };

  return (
    <div className={classes.section}>
      <div className={classes.header}>
        <span>
          {getContent("title")}
        </span>
        <SVG src={config.APP_LOGO}/>
      </div>
      <div className={classes.content}>
        <p>
          {getContent("text")}
        </p>
        <NormalButton buttonType="primary" onClick={handleContinue}>
          {t('next')}
        </NormalButton>
      </div>
    </div>
  );
}

export default Default;